const article = {
	slug: "humane-in-the-loop",
	title: "Being Humane in the Loop",
	date: "23 June 2026",
	updated: null,
	description:
		"\"Human in the loop\" is a comfort statement, not an accountability model. Weighted accountability gives each layer of an AI decision a proportionate share by role, access, and sign-off.",
	keywords: [
		"AI accountability",
		"responsible AI",
		"AI governance",
		"human in the loop",
		"AI leadership",
	],
	tldr: "You can put a human at every decision point and still have zero accountability. Weighted accountability gives each layer a proportionate share, by role, by access, by what they signed off on. Empathy is what makes it real.",
	readingTime: null,
	provenance:
		"Adapted from my LinkedIn post about the ASCEND New Jersey AI panel at UPS, June 2026.",
	provenanceUrl: null,
	series: "ai-governance-for-finserv-leaders",
	artifact: "decision-stall-test",
	markdown: `Being humane in the loop. Not "human in the loop." Humane.

That phrase does not appear in any AI governance framework I have read. It should.

Last week, ASCEND New Jersey held a panel on "AI for Work and Life" at UPS. Joseph Timem, Ramesh Sethi, Raj Chowdhari, and I were on the stage.

The question that kept surfacing: when AI makes a wrong call on a financial decision, a client recommendation, a security alert, who owns it?

## Human in the loop is a comfort statement

Somewhere in that conversation I realized "human in the loop" is not an accountability model. It is a comfort statement. Nobody raises their hand to own what goes wrong.

You can put a human at every decision point. Without weighted, explicit accountability, that person is just a signature on a form they did not read.

The Carnegie Council for Ethics in International Affairs frames the structural problem this way. The humans with access to these systems are a narrow group with a narrow worldview. They do not necessarily understand or represent the people affected.

## Weighted accountability

Weighted accountability is different. The engineer who built the model carries different responsibility than the VP who approved the deployment. The analyst who generated the output is not the exec who sent it to a client.

Each layer owns a proportionate share, by role, by access, by what they signed off on.

That is what "humane in the loop" means. Not just a human somewhere in the chain. A person who owns what they touched.

## Why empathy is not optional

Empathy for the customer who gets a wrong output and has no way to appeal it. Empathy for the compliance officer who has to sign off on something they cannot fully audit. Empathy for the developers who are now asked to deliver 10X productivity with half the people.

AI does not just change what developers can do. It changes what leaders feel entitled to demand. That entitlement, without humane judgment, is its own kind of failure.

AI scales fast. Weighted accountability and empathy do not.`,
};

export default article;
